var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMandantenFaelle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Mandanten_Faelle"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mandanten_Faelle",
    "data-name": "Mandanten | Faelle",
    clipPath: "url(#clip-Mandanten_Faelle)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_120",
    "data-name": "Pfad 120",
    d: "M45.072,37.571H3a3.007,3.007,0,0,1-3-3V3A3.007,3.007,0,0,1,3,0h8.887a2.99,2.99,0,0,1,2.781,1.871L17,6.55a.114.114,0,0,0,.106.071H45.072a3.006,3.006,0,0,1,3,3V34.568a3.006,3.006,0,0,1-3,3M3,1.849A1.156,1.156,0,0,0,1.849,3V34.568A1.156,1.156,0,0,0,3,35.722H45.072a1.155,1.155,0,0,0,1.154-1.154V9.624A1.155,1.155,0,0,0,45.072,8.47H17.106a1.957,1.957,0,0,1-1.8-1.187L12.988,2.631a1.181,1.181,0,0,0-1.1-.782Z",
    transform: "translate(6 12)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandantenFaelle);
export default __webpack_public_path__ + "static/media/Mandanten  Faelle.5685ecba11a6042210a2410a73a67dd3.svg";
export { ForwardRef as ReactComponent };